module.exports = __webpack_public_path__ + "img/act-of-emotion-process-1.5f5bdc20.jpg";